import type { Element, InputText, InputNumber, InputChoiceSet, InputDate, InputTime, InputToggle } from '../types'
import { useCardContext } from './useCardContext'

type InputElement = InputText | InputNumber | InputChoiceSet | InputDate | InputTime | InputToggle

export function findInputElements(elements: Element[]): InputElement[] {
  const result: InputElement[] = []
  if (!Array.isArray(elements)) return result
  for (const el of elements) {
    if (
      el.type === 'Input.Text' ||
      el.type === 'Input.Number' ||
      el.type === 'Input.ChoiceSet' ||
      el.type === 'Input.Date' ||
      el.type === 'Input.Time' ||
      el.type === 'Input.Toggle'
    ) {
      result.push(el)
    } else if (el.type === 'Container') {
      result.push(...findInputElements(el.items))
    } else if (el.type === 'ColumnSet') {
      for (const col of el.columns) {
        result.push(...findInputElements(col.items))
      }
    }
  }
  return result
}

export function useValidation(getElements: () => Element[] | undefined) {
  const { inputs, errors } = useCardContext()

  function validate(): boolean {
    const elements = getElements()
    if (!elements || !Array.isArray(elements)) return true

    const inputElements = findInputElements(elements)
    let valid = true

    for (const input of inputElements) {
      const value = inputs[input.id] ?? ''

      if (input.isRequired && !value) {
        errors[input.id] = input.errorMessage ?? 'This field is required'
        valid = false
      } else if (input.type === 'Input.Text' && input.regex && value) {
        const regex = new RegExp(input.regex)
        if (!regex.test(value)) {
          errors[input.id] = input.errorMessage ?? 'Invalid format'
          valid = false
        }
      } else {
        errors[input.id] = ''
      }
    }

    return valid
  }

  return { validate, inputs, errors }
}
